<template>
  <CreateUserProfileModal
    v-if="showCreateUserProfileModal"
    @closeModal="closeModal"
  />
  <DeleteUserProfileModal
    v-if="showDeleteUserProfileModal"
    :userProfileId="userProfileIdSelected"
    @closeModal="closeModal"
  />
  <CreateUserProfileCodCCustoModal
    v-if="showCreateUserProfileCodCCustoModal"
    :userProfileId="userProfileIdSelected"
    @closeModal="closeModal"
  />
  <DeleteUserProfileCodCCustoModal
    v-if="showDeleteUserProfileCodCCustoModal"
    :userProfileId="userProfileIdSelected"
    :userProfileCodCCustoId="userProfileCodCCustoIdSelected"
    @closeModal="closeModal"
  />
  <div class="mb-3">
    <div class="d-flex justify-content-between">
      <h2 class="fw-light d-flex align-items-center mb-0">
        <router-link
          to="/home"
          class="d-flex align-items-center me-2"
          title="Voltar"
        >
          <i class="ph-caret-circle-left ph-2x" />
        </router-link>
        Gerenciar Permissão de Usuários
      </h2>
      <button
        class="btn btn-success rounded-pill"
        title="Cadastrar Nova Permissão"
        @click="showCreateUserProfileModal = true"
      >
        Cadastrar Nova Permissão
      </button>
    </div>
  </div>
  <LoadingData v-if="isLoading" />
  <ListUsersProfiles
    v-else
    :usersProfiles="usersProfiles"
    @deleteUserProfile="deleteUserProfile"
    @createUserProfileCodCCusto="createUserProfileCodCCusto"
    @deleteUserProfileCodCCusto="deleteUserProfileCodCCusto"
  />
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import CreateUserProfileModal from '@/components/admin/users/CreateUserProfileModal.vue'
import DeleteUserProfileModal from '@/components/admin/users/DeleteUserProfileModal.vue'
import CreateUserProfileCodCCustoModal from '@/components/admin/users/CreateUserProfileCodCCustoModal.vue'
import DeleteUserProfileCodCCustoModal from '@/components/admin/users/DeleteUserProfileCodCCustoModal.vue'
import ListUsersProfiles from '@/components/admin/users/ListUsersProfiles.vue'

export default {
  name: 'AdminUsers',

  components: {
    LoadingData,
    CreateUserProfileModal,
    DeleteUserProfileModal,
    CreateUserProfileCodCCustoModal,
    DeleteUserProfileCodCCustoModal,
    ListUsersProfiles,
  },

  data() {
    return {
      isLoading: true,
      showCreateUserProfileModal: false,
      showDeleteUserProfileModal: false,
      showCreateUserProfileCodCCustoModal: false,
      showDeleteUserProfileCodCCustoModal: false,
      usersProfiles: [],
      userProfileIdSelected: null,
      userProfileCodCCustoIdSelected: null,
    }
  },

  methods: {
    async getUsersProfiles() {
      try {
        this.usersProfiles = await this.$store.dispatch('getUsersProfiles')
        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    deleteUserProfile(userProfileId) {
      this.userProfileIdSelected = userProfileId
      this.showDeleteUserProfileModal = true
    },

    createUserProfileCodCCusto(userProfileId) {
      this.userProfileIdSelected = userProfileId
      this.showCreateUserProfileCodCCustoModal = true
    },

    deleteUserProfileCodCCusto(data) {
      this.userProfileIdSelected = data.userProfileId
      this.userProfileCodCCustoIdSelected = data.userProfileCodCCustoId
      this.showDeleteUserProfileCodCCustoModal = true
    },

    closeModal(reloadListUsersProfiles) {
      if (reloadListUsersProfiles) {
        this.getUsersProfiles()
      }
      this.showCreateUserProfileModal = false
      this.showDeleteUserProfileModal = false
      this.showCreateUserProfileCodCCustoModal = false
      this.showDeleteUserProfileCodCCustoModal = false
    },
  },

  mounted() {
    this.getUsersProfiles()
  },
}
</script>
